import React from 'react'
import { TickBar } from './VisibilityDisplay'

const VisibilityRangesDisplay = ({ min, max, visibleHours, startTickValue, endTickValue }) => {
  // `_getMinMax` can return max === 24 when the end time falls in the 23:xx hour with minutes.
  // Hour boxes are indexed 0–23, so clamp for bar/tick placement.
  const endBarIdx = Math.min(max, 23)
  const endTickIdx = Math.min(max, 24) - 1
  // End times in the last hour (e.g. 23:30) would otherwise share the right edge with 23:59.
  const endTickCentered = endTickIdx === 23 && max > 23
  // Day-end label already shows 23:59 at the right edge — avoid a duplicate end TickBar.
  const hideEndTick = endTickValue === '23:59'

  return (
    <div className='vis-ranges-display'>
      {visibleHours.map((isVisible, idx) => {
        let className = 'vis-box'
        if (isVisible) className += ' filled'
        // if (isVisible === 'partial') className += ' filled-partial'
        // if (isVisible === 'reverse-partial') className += ' reverse-filled-partial'
        // if (isVisible === 'complete') className += ' filled'
        className += idx === min ? ' has-bar left up' : ''
        className += idx === endBarIdx ? ' has-bar right up' : ''
        return (
          <div key={`vis-box-${idx}`} className={className}>
            {min !== max && idx === min && idx !== 0 && (
              <TickBar content={startTickValue} tickPosition='top left' textPosition='top left' />
            )}
            {min !== max && idx === endTickIdx && !hideEndTick && (
              <TickBar
                content={endTickValue}
                tickPosition={endTickCentered ? 'top center' : 'top right'}
                textPosition={endTickCentered ? 'top left' : 'top right'}
              />
            )}
            {idx === 0 && <TickBar content='0:00' tickPosition='bottom left' textPosition='bottom right' />}
            {idx === 23 && <TickBar content='23:59' tickPosition='bottom right' textPosition='bottom left' />}
          </div>
        )
      })}
    </div>
  )
}

export default VisibilityRangesDisplay
